export function expand() {
    var readMoreLink = document.querySelector('.expand-block__link');
    var rightContent = document.querySelector('.expand-block__right');

    function checkWindowSize() {
        if (window.innerWidth <= 980) {
            rightContent.style.display = 'none';
            readMoreLink.style.display = 'inline';
        } else {
            rightContent.style.display = 'block';
            readMoreLink.style.display = 'none';
        }
    }

    if (readMoreLink && rightContent) {
        readMoreLink.addEventListener('click', function () {
            rightContent.style.display = 'block';
            readMoreLink.style.display = 'none';
        });

        window.addEventListener('resize', checkWindowSize);
        checkWindowSize(); // Initial check
    }
}